import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSpinner } from "@fortawesome/pro-solid-svg-icons"
import DefaultWallpaperImage from "../../../static/assets/images/portfolio-banner-default.jpg"
import "./WallpaperImage.css"

/**
 * Display a user's wallpaper image. If they have no profile image, display the
 * default wallpaper
 * @prop {*} profile - User's profile object
 * @prop {string} className - For custom styles
 * @prop {string} potentialReplacementURL - URL of image that, if provided, will be displayed instead of wallpaper image. If "", the default wallpaper will be displayed
 * @prop {boolean} isLoading - Whether to display a loading spinner
 * @returns {JSX}
 */
const WallpaperImage = ({profile, className = "", potentialReplacementURL = null, isLoading = false}) => {
  if (!profile || isLoading) {
    return (
      <div className={`wallpaper-image wallpaper-image-loading ${className}`}>
        <FontAwesomeIcon className="loading-spinner" icon={faSpinner} spin />
      </div>
    )
  }

  let { wallpaperImageUrl } = profile
  let wallpaperUrlToDisplay = ""
  if (potentialReplacementURL) {
    wallpaperUrlToDisplay = potentialReplacementURL
  } else if (potentialReplacementURL === null && wallpaperImageUrl) {
    wallpaperUrlToDisplay = wallpaperImageUrl
  } else {
    wallpaperUrlToDisplay = DefaultWallpaperImage
  }
  
  return (
    <img 
      className={`wallpaper-image wallpaper-image-loaded ${className}`}
      alt="User-uploaded wallpaper image"
      src={wallpaperUrlToDisplay}
    />
  )
}

export default WallpaperImage
